import { useShowSuccess, useShowError } from 'hooks/useToast'
import { useConvertPartManyToManyMutation } from '../../../graphql'
import { StorePart } from '../../../types/storePart'

export default function useConvertPartManyToManyHandler( options?: any ) {
	const [ convertParts ] = useConvertPartManyToManyMutation( options )
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( storePart: StorePart, toPartId: string, fromQuantity: number, toQuantity: number ) => {
		const inventoryLocationId = storePart?.inventoryLocation.id
		const fromPartId = storePart?.part.id.toString()

		const result = await convertParts( { variables: { inventoryLocationId, fromPartId, toPartId, fromQuantity, toQuantity } } )
		if ( result.data?.convertItems?.success ) {
			showSuccess( `convertPartsSuccess${Date.now()}`, result.data?.convertItems?.message ?? 'Successfully converted part' )
		} else {
			showError( `convertPartsError${Date.now()}`, result.data?.convertItems?.message ?? 'Sorry, an error occurred' )
		}
	}
}
